import CustomButton from "components/CustomButton";
import CustomInput from "components/CustomInput/CustomInput";
import { Field, Form, Formik } from "formik";
import React, { useState } from "react";
import Modal from "react-responsive-modal";
import { useParams } from "react-router-dom";
import SurveyService from "services/SurveyService";
import * as Yup from "yup";
import { ReactComponent as CloseIcon } from "assets/img/icons/cancel.svg";
import { useToasts } from "react-toast-notifications";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave, faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { SURVEY_STATUS } from "store/reducers/surveyReducer";

const surveySchema = Yup.object().shape({
  title: Yup.string().trim().required("Title is required."),
});

export default ({ survey, onClose, dispatch, reload, teamSurveys }) => {
  const params = useParams();
  const { addToast } = useToasts();
  const [isSaving, setIsSaving] = useState(false);
  const [isPublishing, setIsPublishing] = useState(false);

  const handleSave = async (data, publish = false) => {
    try {
      if (publish) {
        setIsPublishing(true);
      } else {
        setIsSaving(true);
      }

      const payload = {
        surveyId: survey.id,
        title: data.title,
        teamId: Number(params.teamId),
        isDraft: !publish,
      };

      await SurveyService.createSurvey(payload);

      // Update local state
      const updatedSurveys = teamSurveys.map(s => 
        s.id === survey.id 
          ? { ...s, title: data.title, status: publish ? SURVEY_STATUS.ACTIVE : SURVEY_STATUS.DRAFT }
          : s
      );

      dispatch({
        type: "setTeamSurveys",
        value: updatedSurveys,
      });

      addToast(
        publish 
          ? "Survey published successfully." 
          : "Survey saved as draft successfully.",
        {
          appearance: "success",
        }
      );

      if (publish) {
        setIsPublishing(false);
      } else {
        setIsSaving(false);
      }

      onClose(true);
    } catch (error) {
      if (publish) {
        setIsPublishing(false);
      } else {
        setIsSaving(false);
      }
      addToast("Failed to update survey. Please try again.", {
        appearance: "error",
      });
    }
  };

  return (
    <Modal
      center
      open
      closeOnEsc={false}
      closeOnOverlayClick={false}
      classNames={{
        modalContainer: "modalContainer",
        modal: "createTaskModal",
      }}
      showCloseIcon={false}
      onClose={onClose}
    >
      <div className="modal fade popup-modal withcross create-task-popup">
        <h5 className="text-center createTaskHeading">Edit Survey</h5>
        <CustomButton type="button" buttonClass="btnClose">
          <CloseIcon style={{ width: "20px" }} onClick={() => onClose(false)} />
        </CustomButton>

        <div className="">
          <Formik
            initialValues={{ title: survey.title || "" }}
            validationSchema={surveySchema}
            onSubmit={(values, actions) => {
              // Don't auto-submit, let user choose save or publish
            }}
          >
            {({ values, errors, touched, setFieldValue }) => (
              <Form>
                <Field name="title">
                  {({ field, form }) => (
                    <CustomInput
                      inputProps={{
                        placeholder: "Survey Title",
                        value: field.value,
                        name: "title",
                        error:
                          !!form.errors.title && !!form.touched.title
                            ? form.errors.title
                            : null,
                      }}
                      inputClass="form-feild full_w listInput"
                      onChange={field.onChange}
                    />
                  )}
                </Field>

                <div className="d-flex justify-content-end gap-2 mt-3">
                  <CustomButton
                    type="button"
                    buttonClass="btn btn-outline-secondary"
                    onClick={() => handleSave(values, false)}
                    disabled={isSaving || isPublishing || !values.title.trim()}
                  >
                    <FontAwesomeIcon icon={faSave} className="me-2" />
                    {isSaving ? "Saving..." : "Save as Draft"}
                  </CustomButton>
                  <CustomButton
                    type="button"
                    buttonClass="btn btn grad_btn"
                    onClick={() => handleSave(values, true)}
                    disabled={isSaving || isPublishing || !values.title.trim()}
                  >
                    <FontAwesomeIcon icon={faPaperPlane} className="me-2" />
                    {isPublishing ? "Publishing..." : "Publish"}
                  </CustomButton>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </Modal>
  );
};